import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CoreService } from 'src/app/core/helpers/core.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AuthService } from 'src/app/core/helpers/auth.service';

@Component({
  selector: 'loyaltic-swish-pay',
  templateUrl: './swish-pay.component.html',
  styleUrls: ['./swish-pay.component.scss']
})
export class SwishPayComponent implements OnInit {

  PhoneNumber = '';
  Id = '';
  public modalRef!: BsModalRef;
  @ViewChild("uploadAnimation", { static: false }) uploadAnimationRef: any;
  @ViewChild("paysuccess", { static: false }) paysuccessRef: any;
  
  popupConfig = {
    ignoreBackdropClick: true,
    class:
      "lyltc animation modal-md modal-dialog-animation",
  };
  constructor( private modalService: BsModalService,private authService: AuthService,private route: ActivatedRoute,private router: Router,private translate: TranslateService,private coreService: CoreService,private toast: ToastrService,) {
    this.route.queryParams.subscribe(params => {
      this.Id = params.id;
    });
   }

  ngOnInit() {
    const isLoggedIn = this.authService.IsLoggedIn();
    if (this.Id ==null || this.Id =='') 
    {    
      const errorMessage = this.translate.instant("error-invalid-link");
      this.toast.error(errorMessage, ' ');
      this.router.navigate(['/']);
        
    }
  }

  onSubmit(formRef) {
       const body = {
      Phone: this.PhoneNumber,
      Id: this.Id     
    };

    this.coreService.pay(body).then((response: any) => {
      this.modalRef.hide();
      const message = this.translate.instant(response.messageKey);
      this.toast.success(message, ' ');
      this.modalRef = this.modalService.show(
        this.paysuccessRef,
        this.popupConfig
      );
      // this.onHide();
    }).catch((errorResponse: any) => {
     if(errorResponse==null || errorResponse.error ==null)
     {
      const errorMessage = this.translate.instant("error-internal-server");
      this.toast.error(errorMessage, ' ');
      this.modalRef.hide();     
     }
     else if(errorResponse.error.messageKey=="PaymentReference is invalid" 
             || errorResponse.error.messageKey=="error-invalid-certificate" 
             || errorResponse.error.messageKey=="Payer alias is invalid."
             || errorResponse.error.messageKey=="Missing Merchant Swish Number"
             ||errorResponse.error.messageKey=="Amount value is missing or not a valid number"
             ||errorResponse.error.messageKey=="Specified transaction amount is less than agreed minimum."
             ||errorResponse.error.messageKey=="Amount value is too large"
             ||errorResponse.error.messageKey=="Invalid or missing Currency"
             ||errorResponse.error.messageKey=="Wrong formatted message"
             ||errorResponse.error.messageKey=="Counterpart is not activated."
             ||errorResponse.error.messageKey=="Payer not Enrolled.")
     {
      const errorMessage = this.translate.instant("error-swish-integration");
      this.toast.error(errorMessage, ' ');
      this.modalRef.hide();
     }
     else if(errorResponse.error.messageKey=="Payee not Enrolled.")
      {
        const errorMessage = this.translate.instant("error-payee-not-enrolled");
        this.toast.error(errorMessage, ' ');
        this.modalRef.hide();
      }
      else if(errorResponse.error.messageKey=="error-invalid-chargeid" 
     || errorResponse.error.messageKey=="error-invalid-reward-info")
      {
        const errorMessage = this.translate.instant("error-invalid-link");
        this.toast.error(errorMessage, ' ');
        this.modalRef.hide();
      }
     else
     {
      const errorMessage = this.translate.instant(errorResponse.error.messageKey);
      this.toast.error(errorMessage, ' ');
      this.modalRef.hide();
     }
      
    });
  }

  showSwishPopup() {
    this.modalRef = this.modalService.show(
      this.uploadAnimationRef,
      this.popupConfig
    );
  }

}
